import { Component, HostBinding, OnInit } from '@angular/core';
import { SpinnerService } from '../../api/spinner.service';

@Component({
    selector: 'app-signout-oidc',
    templateUrl: './signout-oidc.component.html',
    styleUrls: ['./signout-oidc.component.scss'],
    standalone: false
})
export class SignoutOidcComponent implements OnInit {
  @HostBinding('class.full-width-container') classBinding = true;

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit(): void {
  
    this.spinnerService.hide();
     setTimeout(() => this.spinnerService.hide(), 100); 
  }

  login(): void {
    window.location.href = '/';
  }
}
